export function hasNonEmptyArray(obj: Record<string, any>): boolean {
  return Object.values(obj).some((value) => Array.isArray(value) && value.length > 0)
}
